import React from 'react'
import { PositionsWrapper } from './PositionStyles'
import PositionButton from './Position'
import { POSITION_PROPS } from './interface'
import useSound from 'use-sound'
import positions from 'lib/assets/audio/positions.mp3'

function Positions({
  audio,
  ante,
  AAbonus,
  active,
  handleActive,
  gameState,
  raise,
  noAnimate,
  anteWin,
  AAWin,
  raiseWin,
  currency,
  betReply,
  precision,
}: POSITION_PROPS) {
  const [playPositionsSFX] = useSound(positions, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })

  return (
    <PositionsWrapper>
      <PositionButton
        title={betReply && +AAbonus > 0 ? 'AA BONUS' : 'BONUS'}
        content={AAbonus}
        active={active === 'bonus'}
        withBet={AAbonus !== 'AA'}
        clickHandler={() => {
          handleActive('bonus')
          active !== 'bonus' && audio?.sound && playPositionsSFX()
        }}
        disabled={gameState !== 0}
        noAnimate={noAnimate}
        betReply={betReply}
        win={AAWin}
        currency={currency}
        precision={precision}
      />
      <PositionButton
        title='ANTE'
        content={ante}
        active={active === 'ante'}
        withBet={ante > '0'}
        clickHandler={() => {
          handleActive('ante')
          active !== 'ante' && audio?.sound && playPositionsSFX()
        }}
        disabled={gameState !== 0}
        noAnimate={noAnimate}
        betReply={betReply}
        win={anteWin}
        currency={currency}
        precision={precision}
      />
      <PositionButton
        title='RAISE'
        active={active === 'raise'}
        disabled={true}
        withBet={raise > '0'}
        content={raise}
        clickHandler={() => handleActive('raise')}
        noAnimate={noAnimate}
        betReply={betReply}
        win={raiseWin}
        currency={currency}
        precision={precision}
      />
    </PositionsWrapper>
  )
}

export default Positions
